import React from 'react'
import {Outlet} from 'react-router-dom'
import {FiLayers} from 'react-icons/fi'
import AssetsMenu from 'navigation/sub-routes/Assets/AssetsMenu'
import {VmoCreateFirst} from 'vmo-library'
import {getPermissionTooltipContent} from 'utils/helper'
import useUserPermissions from 'hooks/pure/useUserPermission'

const items = [
  {
    header: 'Reduce licensing and support costs',
    subHeader:
      'Keep proper track of the asset lifecycle your team can eliminate or reallocate under-utilized resources and licenses',
  },
  {
    header: 'Associate assets with tickets and contacts',
    subHeader:
      'Having knowledge of tickets and contacts linked to an asset, the team gets a complete picture of the issue and the contrast linked the support improves drastically',
  },
  {
    header: 'Get faster resolution of tickets',
    subHeader: 'Adding an asset to a ticket helps to save a lot of time and effort required to resolve a ticket',
  },
]

const AssetsLayout = () => {
  const {advanceFeaturesAccess} = useUserPermissions()
  const allowAssetManagementFeature = advanceFeaturesAccess?.assetManagement

  if (!allowAssetManagementFeature) {
    return (
      <VmoCreateFirst
        headerIcon={<FiLayers />}
        header="Assets"
        subHeader="Assets comprise the underlying components that deliver products and services to the customer. Assets can be hardware assets or software assets. Simplifies a lot of operational problems and keeps both customers and support teams happy."
        items={items}
        primaryButtonProps={{
          buttonText: 'Create Assets',
          onClick: () => {},
          tooltip: !allowAssetManagementFeature,
          tooltipContent: getPermissionTooltipContent({featureAccess: allowAssetManagementFeature}),
        }}
      />
    )
  }

  return (
    <>
      <AssetsMenu />
      <div className="vmoSideBar-wrap">
        <Outlet />
      </div>
    </>
  )
}

export default AssetsLayout
